// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"fb8baca6","outerContainer":"_5f2e6105","secondaryToolbar":"f29414c5","doorHangerRight":"b139a1f7","toolbarContainer":"b78e6d6a","toolbarViewerMiddle":"c019e683","progressBar":"_1483bc28","back-to-application":"_026dbd73","root":"e72772d5","rootHealthRecords":"e246f314","paginationRoot":"_46121842","paginationHealthRecords":"e93ffdc1","emptyStateRoot":"_0e63869a","noDataMessage":"bdcf09e6","paginationLoader":"_30255e26"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientHealthboard/PatientPortal/DataList/index.styl
// module id = 1504
// module chunks = 39